import { Component } from '@angular/core';

/**
 * This is from an example on https://angular.io/guide/upgrade
 * However, this does NOT seem to work when ng-view is added late!
 */
@Component({
    selector: 'app-angular-js',
    template: '<div ng-view=""></div>'
})
export class AngularJSComponent { // implements OnInit, OnDestroy {
    constructor(
        // private lazyLoader: LazyLoaderService,
        // private elRef: ElementRef
    ) {
        console.log('AngularJSComponent constructed');
    }

/*
    ngOnInit() {
        this.lazyLoader.load(this.elRef.nativeElement);
    }

    ngOnDestroy() {
        this.lazyLoader.destroy();
    }
*/
}